export default "__VITE_ASSET__zOp00_no__"